export const pluralize = (count, noun, suffix = 's') => {
  return `${count} ${noun}${Math.abs(count) !== 1 ? suffix : ''}`;
};

export const pluralizeWithoutCount = (count, noun, suffix = 's') => {
  return `${noun}${Math.abs(count) !== 1 ? suffix : ''}`;
};

export const toTitleCase = string =>
  string
    ? string.replace(
        /(^|\s|-)(\w)(\w*)/g,
        (_, separator, firstChar, restOfWord) =>
          separator + firstChar.toUpperCase() + restOfWord.toLowerCase()
      )
    : '';

export const capitalizeLastWord = (string = '') => {
  return string.replace(/\b\w+$/, word => word[0].toUpperCase() + word.slice(1));
};
